import { normalizeText } from './textNormalize';

// Minimum number of entries before the AlphaRail is shown
export const MIN_INDEX_ITEMS = 30;

export const getInitialLetter = (entry) => {
  const value =
    typeof entry === 'string' ? entry : entry?.normalized || entry?.word || entry?.slug || '';
  if (typeof value !== 'string') return '#';
  const first = normalizeText(value).charAt(0).toUpperCase();
  return /[A-Z]/.test(first) ? first : '#';
};

export const getIndexLetters = (entries = []) => Array.from(new Set(entries.map(getInitialLetter)));
